/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

 // Import our global styles, including those from shared components.
import './src/styles/index.scss';
import React from 'react'
import {QueryParamProvider} from 'use-query-params'
import { ReachAdapter } from 'use-query-params/adapters/reach'

export const onClientEntry = async () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE) and react-intersection-observer
  if (!(`IntersectionObserver` in window)) {
    await import('intersection-observer')
  }
  const smoothscroll = await import('smoothscroll-polyfill')
  smoothscroll.polyfill()
}

export const wrapPageElement = ({element}) => <QueryParamProvider adapter={ReachAdapter}>{element}</QueryParamProvider>
export const shouldUpdateScroll = ({routerProps, prevRouterProps}) =>
  // if the previous route's pathname is the same as the current route's pathname,
  // that means only query params have changed, so we don't want to scroll
  // to the top of the page when the URL changes
  !prevRouterProps?.location.pathname || routerProps?.location.pathname !== prevRouterProps?.location.pathname
